import { useTranslation } from 'next-i18next';

import { useEffect, useState } from 'react';

import { Box, Flex, IconButton, Portal, Tooltip } from '@chakra-ui/react';

import { IconsLinear } from '@nocowanie/icons/linear';

import { SelectDatesTooltipProps } from './select-dates-tooltip.props';

export const SelectDatesTooltip = ({
    children,
    open: controlledOpen,
    onOpenChange,
}: SelectDatesTooltipProps) => {
    const { t } = useTranslation('listing', { keyPrefix: 'selectDates' });
    const [internalOpen, setInternalOpen] = useState(false);

    const isOpen = controlledOpen ?? internalOpen;

    const setIsOpen = (value: boolean) => {
        if (controlledOpen !== undefined) {
            onOpenChange?.(value);
        } else {
            setInternalOpen(value);
        }
    };

    if (typeof window.WP === 'undefined') {
        window.WP = [];
    }

    useEffect(() => {
        const show = () => setIsOpen(true);

        if (window.WP?.gdpr) {
            window.WP.push(() => {
                window.WP.gdpr.runAfterConsent(show);
            });
        } else {
            show();
        }
    }, []);

    useEffect(() => {
        if (!isOpen) return;

        const close = () => setIsOpen(false);
        window.addEventListener('touchmove', close, { capture: true, passive: true });

        return () => {
            window.removeEventListener('touchmove', close, true);
        };
    }, [isOpen]);

    return (
        <Tooltip.Root
            open={isOpen}
            interactive
            positioning={{ placement: 'bottom-start', offset: { mainAxis: 0 } }}
        >
            <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
            <Portal>
                <Tooltip.Positioner>
                    <Tooltip.Content zIndex={'popover'}>
                        <Tooltip.Arrow css={{ transform: 'translateX(-160px)' }}>
                            <Tooltip.ArrowTip />
                        </Tooltip.Arrow>
                        <Flex justify={'space-between'} gap={2} py={1} w={'240px'}>
                            <Box
                                as={'span'}
                                fontSize={'sm'}
                                ml={0.5}
                                dangerouslySetInnerHTML={{ __html: t('label') }}
                            />
                            <IconButton
                                variant={'ghost'}
                                aria-label={t('closeBtn')}
                                onClick={() => setIsOpen(false)}
                                fontSize={'md'}
                                color={'white'}
                                minW={'auto'}
                                h={'auto'}
                                alignSelf={'flex-start'}
                            >
                                <IconsLinear.Close />
                            </IconButton>
                        </Flex>
                    </Tooltip.Content>
                </Tooltip.Positioner>
            </Portal>
        </Tooltip.Root>
    );
};
